<template>
  <section
    class="pt-10 px-6 md:px-10 lg:px-40 text-center flex flex-col items-center font-sora"
  >
    <div class="max-w-4xl mx-auto">
      <!-- Başlık -->
      <h2
        class="text-2xl sm:text-3xl md:text-4xl lg:text-5xl font-semibold leading-snug mb-6"
      >
        <span class="text-[#666]">{{ t("section.title1") }}</span>
        <br />
        <span class="text-white font-bold">
          {{ t("section.title2") }}
        </span>
      </h2>

      <!-- Alt açıklama -->
      <p
        class="text-base sm:text-lg md:text-xl lg:text-2xl font-light text-[#999] leading-relaxed"
      >
        <button
          class="underline text-[#0c71c3] hover:text-gray-400 transition"
          @click="openSignup"
        >
          {{ t("section.signup") }}
        </button>
        {{ " " }} veya
        <button
          class="underline text-[#0c71c3] hover:text-gray-400 transition"
          @click="openLogin"
        >
          {{ t("section.login") }}
        </button>
        ; {{ t("section.desc") }}
      </p>
    </div>
  </section>
</template>

<script setup>
import { useAuthModal } from "~/composables/useAuthModal";

const { openLogin, openSignup } = useAuthModal();

const { t } = useI18n();
</script>
